module.exports = __webpack_public_path__ + "img/header.bafb3bb8.svg";